import { createTheme } from '@mui/material/styles';
import '@mui/material/Button';

declare module '@mui/material/styles' {
  interface Palette {
    black: Palette['primary'];
    charcoal: Palette['primary'];
    gray: Palette['primary'];
    light: Palette['primary'];
    red: Palette['primary'];
    white: Palette['primary'];
  }
  interface PaletteOptions {
    black: PaletteOptions['primary'];
    charcoal: PaletteOptions['primary'];
    gray: PaletteOptions['primary'];
    light: PaletteOptions['primary'];
    red: PaletteOptions['primary'];
    white: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    black: true;
    charcoal: true;
    gray: true;
    light: true;
    red: true;
    white: true;
  }
}

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 520,
      md: 800,
      lg: 960,
      xl: 1536,
    },
  },
  palette: {
    black: {
      main: '#000000',
      contrastText: '#ffffff',
    },
    charcoal: {
      main: '#37455d',
      contrastText: '#ffffff',
    },
    gray: {
      main: '#5c5c5c',
      contrastText: '#ffffff',
    },
    light: {
      main: '#e5e6e5',
      contrastText: '#000000',
    },
    red: {
      main: '#da0024',
      contrastText: '#ffffff',
    },
    white: {
      main: '#ffffff',
      contrastText: '#000000',
    },
    text: {
      primary: '#5c5c5c',
    },
  },
  typography: {
    fontFamily: ['NotoSansJP', 'Noto Sans JP', 'sans-serif'].join(','),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: 'inherit',
          },
        },
        asterisk: {
          display: 'none',
        },
      },
    },
  },
});

export default theme;
